import request from '../../../utils/request';
import {
  ICreateO365Onboarding,
  IO365OnboardingConsentUrl,
  IO365OnboardingCreated,
  O365OnboardingListItem,
  O365VerifyResult,
} from './o365Onboarding.model';

class O365OnboardingService {
  ENDPOINT = '/o365-onboarding';

  public async list(): Promise<O365OnboardingListItem[]> {
    const res = await request({ url: this.ENDPOINT, method: 'GET' });
    return res.data.body.data;
  }

  public async create(data: ICreateO365Onboarding): Promise<IO365OnboardingCreated> {
    const res = await request({ url: this.ENDPOINT, method: 'POST', data });
    return res.data.body.data;
  }

  public async getConsentUrl(id: number): Promise<IO365OnboardingConsentUrl> {
    const res = await request({ url: `${this.ENDPOINT}/${id}/consent-url`, method: 'GET' });
    return res.data.body.data;
  }

  public async verify(id: number): Promise<O365VerifyResult> {
    const res = await request({ url: `${this.ENDPOINT}/${id}/verify`, method: 'POST' });
    return res.data.body.data;
  }

  public async resetTenant(id: number): Promise<void> {
    await request({ url: `${this.ENDPOINT}/${id}/reset-tenant`, method: 'POST' });
  }
}

export default new O365OnboardingService();
